/**
 * A short label/value list for an expanded row ("Your baseline" / "Now"): a
 * 96px helper-text label column and the value, usually a Tag (a default tag
 * for the baseline value, the high-contrast tag for the drifted one). A
 * description list, so each label names its value.
 */
import type { ReactNode } from 'react'
import clsx from 'clsx'

export interface DiffRow {
  label: ReactNode
  value: ReactNode
}

export interface DiffListProps {
  rows: DiffRow[]
  className?: string
}

export function DiffList({ rows, className }: DiffListProps) {
  return (
    <dl className={clsx('m-0 grid gap-2', className)}>
      {rows.map((row, i) => (
        <div key={i} className="grid grid-cols-[96px_minmax(0,1fr)] items-center gap-3">
          <dt className="text-helper text-text-helper">{row.label}</dt>
          <dd className="m-0 min-w-0 max-w-full justify-self-start">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}

export default DiffList
